export default {
    beforeMount(el, binding) {
        el._toUpperHandler = (e) => {
            if (binding.value === false) return; // kapalıysa çalışmasın

            const start = el.selectionStart;
            const current = el.value;
            const uppercased = current.toLocaleUpperCase("tr");

            if (current !== uppercased) {
                el.value = uppercased;
                el.setSelectionRange(start, start);
                // sadece değiştiyse tetikle
                el.dispatchEvent(new Event("input", { bubbles: true }));
            }
        };

        el.addEventListener("input", el._toUpperHandler);
    },
    updated(el, binding) {
        // directive aktif/pasif bilgisini güncelle
        el._isActive = binding.value;
    },
    unmounted(el) {
        el.removeEventListener("input", el._toUpperHandler);
    },
};
